import { reloadPageIfObsolete } from "./window";

/** @deprecated Use 'import { reloadPageIfObsolete } from "pli/util/window"' */
export = reloadPageIfObsolete;



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/util/reloadPageIfObsolete.ts